module.exports = __webpack_public_path__ + "img/6.68a5e637.jpg";